
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import MailService from '@/apps/shared/services/email-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import StatePricingService from '@/apps/shared/services/statePricing-service';
    import ContractFinish from "@/apps/shared/components/ContractFinish.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';

    interface payload {
        productId: number;
        pricingId: number;
        contratante: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            documentType: string;
            areaCode: string;
            telephone: string;
            email: string;
        };
        plan: {
            planName: string;
            premioMensual: string;
            sumAssured: string;
        };
        vehicle: {
            vehicleDescription: string;
            vehicleBrand: string;
        };
        localityId: number;
        leadId: string;
        referente: string;
    }
    interface getParamCotizResponse {
        hasData: boolean;
        message: string;
        data: string | null;
    }


    export default Vue.extend({
        components: {
            ContractFinish
        },
        name: 'UrbanMobilityFinalPayment',
        data() {
            return {
                titleAndPromotionDetails: {
                    icon: {
                        src: '/icons/check.png',
                    },
                } as TitleAndPromotionsDetails,
                payload: null as payload | null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                const actualPath = '/movilidad';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                this.$router.push({ name: 'tabOne' });
            },

            fetchSessionPayload(guid: string): Promise<void> {
                return ParamCotizService.getParamCotiz(guid)
                    .then(resp => {
                        if (!resp.hasData || !resp.data) {
                            console.warn(resp.message);
                            throw new Error(resp.message);
                        }
                        this.payload = JSON.parse(resp.data) as payload;
                    });
            },

            getMailValues() {
                const payload = this.payload;

                const nombreRaw = payload.contratante.firstName.toLowerCase().split(' ')[0];
                const firstName = nombreRaw.charAt(0).toUpperCase() + nombreRaw.slice(1);

                const effectDate = new Date();
                const vigencyDate = new Date(effectDate);
                vigencyDate.setFullYear(effectDate.getFullYear() + 1);

                const parameters = [
                    { name: "@ReportCode", value: "26" },
                    { name: "@contratante", value: firstName },
                    { name: "@nombrePlan", value: payload.plan.planName },
                    { name: "@vigenciaDesde",
                        value:
                            effectDate.getDate() + "/" +
                            (effectDate.getMonth() + 1) + "/" +
                            effectDate.getFullYear()
                    },
                    { name: "@vigenciaHasta",
                        value:
                            vigencyDate.getDate() + "/" +
                            (vigencyDate.getMonth() + 1) + "/" +
                            vigencyDate.getFullYear()
                    },
                    { name: "@costoMensual", value: payload.plan.premioMensual },
                    { name: "@vehicleSelected", value: payload.vehicle.vehicleDescription },
                    { name: "@vehicleBrand", value: payload.vehicle.vehicleBrand },
                    { name: "@sumaAsegurada", value: payload.plan.sumAssured }
                ];

                const mailPayload = {
                    parameters: parameters,
                    to: payload.contratante.email,
                    from: "cotizador@sancorseguros.com",
                    productId: payload.productId
                };

                return JSON.stringify(mailPayload);
            },
            async addFinishQuotation() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const leadId = this.payload.leadId;
                var planData =  this.payload.plan;
                var externalIdentifier = this.payload.pricingId.toString();

                StatePricingService.getStatePricing(
                    1,
                    null,
                    externalIdentifier,
                    30
                );

                var clientData = this.payload.contratante;
                var premioMensual = Number.isInteger(planData.premioMensual)
                    ? planData.premioMensual
                    : parseInt(planData.premioMensual.replace(/\./g, ''), 10);
                var localidad = this.payload.localityId;
                var ramo = "Movilidad";
                var FormattedPremioMensual = planData.premioMensual.toString().includes(".") ? planData.premioMensual.toString().replaceAll('.', '') : planData.premioMensual;

                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.payload.contratante.email,
                    'product': 'movilidad',
                    'event': 'cotizador-movilidad-venta-completa',
                    'value': parseInt(FormattedPremioMensual.replaceAll('.', ''), 10), 
                    'referente': this.payload.referente
                });

                StatePricingService.getStatePricing(
                    1,
                    null,
                    externalIdentifier,
                    31
                );
                NF.UI.Page.block();

                //--------------Llamada al AddFinishedQuotation (Dentro del finish())---------------------
                await CUPEService.Finish(parseInt(externalIdentifier), 936, clientData.lastName, clientData.documentNumber, localidad, clientData.email, clientData.firstName, externalIdentifier, premioMensual, planData.planName, ramo, clientData.areaCode, clientData.telephone).then(async (FinishResult) => {
                    if (FinishResult) {
                        CRMCotizadorWebService.CreateOrEditLead(leadId, null, location.href, null, null, 936, true, "7", null, null, null);

                        //StatePricingService.getStatePricing(
                        //    1,
                        //    null,
                        //    externalIdentifier,
                        //    40
                        //);

                        //ENVIO DE EMAIL
                        await MailService.sendMail(this.getMailValues()).then(response => {
                            let notificationType = response.result ? NF.Notification.Type.SUCCESS : NF.Notification.Type.ERROR;
                            let notificationTitle = response.result ? 'Mail Enviado' : 'Error';
                            let notificationContent = response.result ? 'Mail enviado exitosamente.' : 'Se produjo un error inesperado.';
                            NF.Notification.show({
                                type: notificationType,
                                title: notificationTitle,
                                content: notificationContent,
                                position: NF.Notification.Positions.TOP_RIGHT,
                                clickClose: true,
                                autoHideDelay: 10000,
                            });
                        }).finally(() => NF.UI.Page.unblock());
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.payload.email,
                            'product': 'movilidad',
                            'event': 'errorServidor',
                            'paso': 'cotizador-movilidad-venta-completa',
                            'referente': this.payload.referente
                        });
                    }
                });
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const guid = sessionStorage.getItem('ParamId');
                if (!guid) {
                    console.error('No hay ParamId en sessionStorage');
                    return;
                }

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.fetchSessionPayload(guid)
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                await this.addFinishQuotation();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
